<template>
    <div>
        <h1 style="text-align: center;">Lesson Plan Component Editor</h1>
        <div v-if="isLoading" class="loading">PLEASE WAIT...</div>
        <div>
            <div ref="cntTitle">
                <h2>Title</h2>
                <div><input type="text" v-model="title" style="width: 100%"></div>
            </div>
            <div ref="cntThumb">
                <h2>Thumbnail</h2>
                <div><img :src="thumbnail.data" height="200px" width="100%" style="object-fit: contain;"></div>
                <div><input type="file" ref="thumbsel" v-on:change="changeThumb()" accept="image/jpeg" style="width: 100%; color: black;"></div>
            </div>
            <hr>
            <div ref="cntPages">
                <div style="display: flex">
                    <span style="color: black">No. of pages:</span>
                    <input style="flex: 50%;" type="number" v-model="contentLength" min="1" @change="onChangeContentLength()">
                </div>
            </div>
            <hr>
            <div ref="cntPDF">
                <div style="color:black">PDF Document : <span>{{ pdf.publicUrl }}</span></div>
                <div><input type="file" ref="pdfsel" accept="application/pdf" style="width: 100%; color: black;" @change="pdf.file = $event.target.files[0]"></div>
            </div>
            <hr>
            <div style="display: flex; flex-direction: column">
                <h2 style="text-align: center;">Fill in the blanks</h2>
                <div style="display: flex; flex-direction: row;">
                    <span style="flex: 1; text-align: center; font-weight: 900; padding: 0.5em; border: 1px solid white;">Page Number</span>
                    <span style="flex: 1; text-align: center; font-weight: 900; padding: 0.5em; border: 1px solid white;">Blank Number</span>
                    <span style="flex: 1; text-align: center; font-weight: 900; padding: 0.5em; border: 1px solid white;">Content</span>
                    <span style="flex: 0.15; text-align: center; font-weight: 900; padding: 0.5em; border: 1px solid white;">Action</span>
                </div>
                <div v-for="(blank, bi) in data" :key="'blank-' + bi" :ref="'blank-' + bi">
                    <div style="display: flex; flex-direction: row;">
                        <input type="number" v-model="blank.page" placeholder="Page No." style="flex: 1; text-align: center;font-weight: 700;">
                        <input type="number" v-model="blank.index" placeholder="Blank No. on page" style="flex: 1; text-align: center;font-weight: 700;">
                        <input type="text" v-model="blank.text" placeholder="Content" style="flex: 1; text-align: center;font-weight: 700;">
                        <button style="flex: 0.15; background: red; color: white;" @click="deleteBlank(bi)">🗑</button>
                    </div>
                </div>
                <button style="background: green; color: white; font-weight: 900;" @click="addBlank()">+ Add New</button>
            </div>
            <hr>
            <div style="display: flex; flex-direction: column" v-if="availableComponents.length > 0">
                <h2 style="text-align: center;">Attached Components</h2>
                <div style="display: flex; flex-direction: row;">
                    <span style="flex: 1; text-align: center; font-weight: 900; padding: 0.5em; border: 1px solid white;">Component</span>
                    <span style="flex: 1; text-align: center; font-weight: 900; padding: 0.5em; border: 1px solid white;">Page Number</span>
                    <span style="flex: 0.15; text-align: center; font-weight: 900; padding: 0.5em; border: 1px solid white;">Action</span>
                </div>
                <div v-for="(child, ci) in children" :key="'child-' + ci" :ref="'child-' + ci">
                    <div style="display: flex; flex-direction: row;">
                        <select v-model="child.id" style="flex: 1; text-align: center; font-weight: 900; padding: 0.5em; border: 1px solid white; border-bottom: 2px solid black;">
                            <option value="">--SELECT A COMPONENT--</option>
                            <option :value="comp.id" v-for="comp in availableComponents" :key="comp.id">{{comp.id}} [{{comp.type}}] || {{comp.title}}</option>
                        </select>
                        <input type="number" v-model="child.location" placeholder="Page No." style="flex: 1; text-align: center;font-weight: 700;">
                        <button style="flex: 0.15; background: red; color: white;" @click="deleteChild(bi)">🗑</button>
                    </div>
                </div>
                <button style="background: green; color: white; font-weight: 900;" @click="addChild()">+ Add New</button>
            </div>
            <div>
                <button @click="submitThis()" class="submit-btn">Submit</button>
            </div>
        </div>
    </div>
</template>

<script>
import {Functions} from './functions.js';
export default {
    name: "BOOKAddEditComponent",
    props: ["ID"],
    data: () => ({
        isLoading: true,
        title: "",
        data: [],
        children: [],
        contentLength: 1,
        // allComponentTypes: [],
        thumbnail: {
            file: undefined,
            data: "",
            publicUrl: "",
            uploadUrl: ""
        },
        pdf: {
            file: undefined,
            publicUrl: "",
            uploadUrl: ""
        },
        functions: undefined,
        availableComponents: []
    }),
    mounted: function(){
        console.clear();
        this.functions = new Functions();
        if(this.ID){
            console.log("Editing");
            this.functions.getComponent(this.ID, (data) => {
                console.log(data);
                this.functions.getAllComponents((allComponents) => {
                    let buffChildren = [];
                    allComponents.forEach((comp) => {
                        if(comp.ParentContent == this.ID){
                            // buffChildren.push(comp);
                            this.children.push({
                                id: parseInt(comp.ID),
                                location: parseInt(comp.ParentLocation)
                            });
                        }
                    });
                    //-->>
                    // console.log(buffChildren);
                    this.thumbnail.publicUrl = data.rdsDat[0].Thumbnail;
                    this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, "image/jpeg,image/png,image/tif", "getObject", (thumbBuff) => {
                        this.thumbnail.data = (thumbBuff.signedUrl);
                        this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, "image/jpeg,image/png,image/tif", "putObject", (thumbBuff1) => {
                            this.thumbnail.uploadUrl = thumbBuff1.signedUrl;
                            this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Location, "application/pdf", "putObject", (pdfdat) => {
                                this.pdf.publicUrl = data.rdsDat[0].Location;
                                this.pdf.uploadUrl = pdfdat.signedUrl;
                                this.title = data.title;
                                data.data.forEach((bl, pg) => {
                                    bl.forEach((blnk, ind) => {
                                        this.data.push({
                                            page: pg+1,
                                            index: ind+1,
                                            text: (blnk == null) ? "" : blnk
                                        });
                                    });
                                });
                                console.log(this.children);
                                this.init();
                            });
                        });
                    });
                });
            });
        }else{
            this.functions.getThumbURL((dat) => {
                this.thumbnail.publicUrl = dat.key;
                this.thumbnail.uploadUrl = dat.signedUrl;
                let uuid = this.functions.generateuuid(32);
                this.functions.getSignedUrl("ttedu-static", "book/" + uuid + ".pdf", "application/pdf", "putObject", (pdfdat) => {
                    this.pdf.publicUrl = "book/" + uuid + ".pdf";
                    this.pdf.uploadUrl = pdfdat.signedUrl;
                    this.init();
                });
            });
        }
    },
    methods: {
        changeThumb: function(){
            var reader = new FileReader();
            reader.onload = (e) => {
                this.thumbnail.data = e.target.result;
            }
            reader.readAsDataURL(this.$refs.thumbsel.files[0]);
            this.thumbnail.file = this.$refs.thumbsel.files[0];
        },
        init: function(){
            if(this.ID){
                //do nothing
            }else{
                this.addChild();
                this.addChild();
                this.addBlank();
                this.addBlank();
            }
            this.functions.getAllComponents((dat) => {
                this.availableComponents = [];
                dat.forEach(d => {
                    if((d.ParentContent == null || d.ParentContent == this.ID) && d.Component != null)
                    this.availableComponents.push({
                        type: d.Component,
                        title: d.Title,
                        id: d.ID
                    });
                });
                // console.log(JSON.stringify(this.availableComponents));
                // this.allComponentTypes = [...new Set(this.availableComponents.map(x => x.type))]
                this.isLoading = false;
            });
        },
        addChild: function(){
            this.children.push({
                id: "",
                location: ""
            });
        },
        addBlank: function(){
            this.data.push({
                page: 1,
                index: 1,
                text: ""
            });
        },
        deleteBlank: function(i){
            let c = confirm("Are you sure you want to delete this?");
            if(c){
                this.data.splice(i, 1);
            }
        },
        deleteChild: function(i){
            let c = confirm("Are you sure you want to delete this child?");
            if(c){
                this.children.splice(i, 1);
            }
        },
        onChangeContentLength: function(){
            this.contentLength = parseInt(this.contentLength);
            this.contentLength = (this.contentLength > 0) ? this.contentLength : 1;
        },
        submitThis: function(){
            this.isLoading = true;
            let hasError = false;
            if(this.title.trim() == "") {this.$refs.cntTitle.classList.add("has-error"); hasError = true;}
            else this.$refs.cntTitle.classList.remove("has-error")
            if(this.thumbnail.file == undefined && this.ID == undefined) {this.$refs.cntThumb.classList.add("has-error"); hasError = true;}
            else this.$refs.cntThumb.classList.remove("has-error")
            if(this.pdf.file == undefined && this.ID == undefined) {this.$refs.cntPDF.classList.add("has-error"); hasError = true;}
            else this.$refs.cntPDF.classList.remove("has-error")

            this.data.forEach((x,i) => {
                if(parseInt(x.page) <= 0 || parseInt(x.index) <= 0 || x.text.trim() == ""){
                    this.$refs['blank-' +  i][0].classList.add("has-error");
                    hasError = true;
                }else this.$refs['blank-' +  i][0].classList.remove("has-error");
            });

            this.children.forEach((x,i) => {
                if(x.id === "" || parseInt(x.location) <= 0){
                    this.$refs['child-' +  i][0].classList.add("has-error");
                    hasError = true;
                }else this.$refs['child-' +  i][0].classList.remove("has-error");
            });

            if(hasError){
                alert("Please fill in the missing content");
                this.isLoading = false;
                return;
            }
            
            let componentData = this.compileData();
            console.log(componentData);
            if(this.ID){
                //update code
                if(this.thumbnail.file == undefined){
                    // No thumbnail to update
                    if(this.pdf.file == undefined){
                        //----- No PDF to upload
                        this.functions.updateBook(this.ID, componentData, (dat) => {
                            console.log(dat);
                            this.$router.push("/editors/component/LessonPlan");
                        });
                    }else{
                        this.functions.uploadPDF(this.pdf.uploadUrl, this.pdf.file, (dat) => {
                            this.functions.updateBook(this.ID, componentData, (dat) => {
                                console.log(dat);
                                this.$router.push("/editors/component/LessonPlan");
                            });
                        });
                    }
                }else{
                    this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                        if(this.pdf.file == undefined){
                            //----- No PDF to upload
                            this.functions.updateBook(this.ID, componentData, (dat) => {
                                console.log(dat);
                                this.$router.push("/editors/component/LessonPlan");
                            });
                        }else{
                            this.functions.uploadPDF(this.pdf.uploadUrl, this.pdf.file, (dat) => {
                                this.functions.updateBook(this.ID, componentData, (dat) => {
                                    console.log(dat);
                                    this.$router.push("/editors/component/LessonPlan");
                                });
                            });
                        }
                    });
                }
            }else{
                //add new
                // this.isLoading = false;
                // console.log(componentData);return null;
                this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                    this.functions.uploadPDF(this.pdf.uploadUrl, this.pdf.file, (dat) => {
                        this.functions.addBook(componentData, (dat) => {
                            console.log(dat);
                            this.$router.push("/editors/component/LessonPlan");
                        });
                    });
                });
            }
        },
        compileData: function(){
            let componentData = {
                ContentType: "BOOK",
                Title: this.title,
                Thumbnail: this.thumbnail.publicUrl,
                Component: null,
                Data: [],
                ContentLength: this.contentLength,
                Location: this.pdf.publicUrl,
                Children: JSON.stringify(this.children)
            };
            let buff = [];
            this.data.forEach(d => {
                if(buff[parseInt(d.page)-1]){
                    buff[parseInt(d.page)-1][parseInt(d.index) - 1] = d.text;
                }else{
                    buff[parseInt(d.page)-1] = [];
                    buff[parseInt(d.page)-1][parseInt(d.index) - 1] = d.text;
                }
            });
            componentData.Data = JSON.parse(JSON.stringify(buff));
            return componentData;
        }
    }
};
</script>

<style scoped>
    hr{
        border: solid 2px white;
    }
    h2{
      color:black;
    }
    .quill-editor{
        background: white;
        color: black;
    }
    .ql-container.ql-snow{
        background: white !important;
    }
    .submit-btn{
        width: 100%;
        height: 2em;
        font-size: 1.5em;
        font-weight: 800;
        margin-top: 0.5em;
    }
    .has-error{
        border: red 5px solid !important;
        box-sizing: border-box;
    }
    .has-error::after{
        content: "Missing content/invalid content.";
        color: red;
        background: white;
        font-weight: 800;
    }
    .loading{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        vertical-align: middle;
        justify-content: center;
        text-align: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        display: flex;
        font-size: 4em;
        font-weight: 900;
    }
</style>